import { useQuery } from "react-query";

import { fetchSdlDataConfig } from "../../../services";
import { IKeyStringAndValue } from "../../types/Types";

const useGetSdlConfig = (listView: string) => {
  return useQuery("config", async () => {
    const config = await fetchSdlDataConfig(listView, "config");
    const configValues =
      config.data.items.edges[0].node.content.data.settings.$values;
    return configValues.map((fields: IKeyStringAndValue) => {
      const splitArray = fields.value.split("|");

      const label = fields.name;
      const key = splitArray[0].trim();
      const filter =
        splitArray.filter((element: string) => element.trim() === "filter")
          .length > 0;
      const hideColumn =
        splitArray.filter((element: string) => element.trim() === "nocol")
          .length > 0;
      return { label, filter, key, hideColumn };
    });
  });
};

export default useGetSdlConfig;
